import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import mathis from "../assets/bebe/mathis.jpg"
import louna from "../assets/bebe/louna.jpg"
import mariloue from "../assets/bebe/mariloue.jpg"
import tc from "../assets/bebe/tc.jpg"
import img1 from "../assets/img/bandeau.jpg";
import mathis1 from "../assets/bebe/mariloue.jpg";
import mathis2 from "../assets/bebe/louna2.jpg";


export const BebeBouleDeJoie = () => {
  return (
    <>

      <div className="banner-titre-container">
        <img src={img1} className="back-img" />
        <div className='over-banner'>
          <div className='info-banner'>
            <h1 className='banner-title'> Bienvenue sur Terre petit ange ...</h1>
          </div>
        </div>
      </div>

      <div className='block-container bottom-space side-space-margin top-space-margin'>
        <Row>
          <Col xs={12} lg={9}>

            <div className='central-block central-block-margin'>
              <div id="left">	  <strong style={{
                textAlign: 'center',
                fontFamily: 'Raleway, sans-serif',
                fontWeight: 600,
                fontSize: '30px'
              }}>Accueil des Nouveau-Nés : Bébé Channeling</strong>
                <p align="left">&nbsp;</p>
                <h2 align="center"><img src={mathis1} alt="" width="200" height="127" /></h2>
                <p class="style9">&nbsp;</p>
                <p class="style9"><strong>Bébé-Boule-de-Joie, 72 h avant sa naissance :</strong></p><br /><br />
                <p class="style9">"Les portes sont grandes ouvertes. Les trompettes de Jéricho annoncent l'arrivée victorieuse de ... B E B E ! Hourra.</p><br />
                <p class="style9">Conception : réussie. Gestation : harmonieuse. Atterrissage : presque accompli. Avec l'aide d'une femme sage et d'une sage-femme, me voici fin prête pour épouser  mon nouveau corps, ma nouvelle vie.</p><br />
                <p class="style9">Salutations fraternelles, mes amis-parents ! J'entre en scène, comme un artiste attendu. C'est bon de se faire attendre, mon 'orgueil' d'âme s'en réjouit. Merci de cet accueil chaleureux. </p><br />
                <p class="style9">Je génère de la Joie, du Mouvement, de l'Expectative, des Espoirs, des Envies-de-tout-recommencer-à-zéro. Je draine avec moi, dans les eaux qui m'entourent, l'énergie du renouveau dans laquelle je baigne. Vous pourriez recueillir une partie de ces fluides pour les utiliser comme engrais fortifiant. Trouvez-leur une utilisation, il ne faut pas gâcher cette belle énergie.</p><br />
                <p class="style9"><strong>Je suis comme un tourbillon,</strong> là où je passe, je me fais remarquer. Ce n'est pas briller pour briller, c'est parce que la nature exubérante de mon âme ne peut concevoir de passer inaperçue. Je ne peux contenir toute cette joie, cette énergie de passion et de partage. Et, puisque je déborde de dons généreux, laissez-moi m'exprimer, ne m'obligez pas à me contenir, ne m'enfermez pas dans les cadres d'obligations sociales, de comportements stéréotypés. </p>
                <p class="style9">Accompagnez-moi, suivez-moi et laissez-moi vous expliquer quand vous aurez l'impression que les choses vont trop vite et que vous aurez du mal à me suivre." </p><br />
                <p class="style11"><strong>S'adressant à son Père :</strong></p><br />
                <p class="style9">"Mon énergie débordante t'obligera à canaliser la tienne pour me contenir ; rends-moi ce service s'il te plaît !"</p><br />
                <p class="style11"><strong>S'adressant à sa Mère :</strong></p><br />
                <p class="style9">"Je serai ton rayon de soleil, réfléchissant les mille milliers d'étincelles du cristal dont tu es porteuse toi-même. Tu te reconnaîtras dans certaines de mes qualités ... Ta douceur, ton regard compréhensif et bienveillant agiront comme un baume apaisant sur mon feu intérieur. "</p><br />
                <p class="style11"><strong>S'adressant aux deux :</strong></p><br />
                <p class="style9">"J'ai des parents parfaits pour me permettre de cheminer. Je suis heureuse du cadeau que mes Frères Divins m'ont fait en me permettant de vous choisir. C'est au sein de votre couple que je pourrai grandir sereinement, en ayant toute la place pour m'épanouir. Votre couple, original et complémentaire, prend pour moi des allures de berceau rassurant. Tel est mon besoin, tel est le lieu où j'ai accepté de naître, entourée de vos deux forces d'Amour.</p><br />
                <p class="style9">Je suis fin prête à venir... je savoure ces derniers instants mi-figue, mi-raison, entre mes deux réalités. Je ressens la joie, l'excitation de celle, de celui qui s'apprête à partir en voyage ... délicieuse sensation du ici et maintenant pleine d'expectatives heureuses, prometteuses.</p><br />
                <p class="style9">Avec votre aide, je me glisserai dans le tunnel, me sachant reliée et accueillie. Merci de votre présence-conscience. Merci de m'avoir offert ce cadeau-corps. Je me sens bien.</p><br />
                <p class="style9">Bientôt dans vos bras. Pas d'inquiétude. C'est pour bientôt !"</p><br />
                <p class="style9"><strong>Image :</strong> Bébé s'endort paisiblement après cette expression de soi dans la Joie. Un ange s'en va sur la pointe des pieds ...</p><br />
                <p class="style9">Amen.</p>
              </div>


            </div>
          </Col>
          <Col xs={12} lg={3}>
            <div className='right-block'>
              <div id="right">
                <h3 class="style5">&nbsp;</h3>
                <p align="left" class="style11"><strong>Parents de Bébé-Boule-de-Joie :</strong></p>
                <i><p align="left" class="style10">"Nous avons demandé ce channeling pour mieux accueillir notre enfant. Nous ne voulions pas connaître son sexe, c'est pourquoi l'âme s'est présenté comme Bébé-Boule-de-Joie ...</p>
                  <p align="left" class="style10">Notre fille, Marielou Soa, est née trois jours après, à la maison. Elle est en pleine forme et effectivement très gaie. "</p></i>
                <p align="left" class="style4">&nbsp;</p>
                <div className='bouton-rectangle-container'>
                  <Link to={'/contact'} className='bouton-rectangle-music'>
                    Me contacter
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

